var chunkMapping = {
	"636": [
		4832,
		9122,
		4249
	],
	"1471": [
		1471
	],
	"2643": [
		2643
	],
	"3013": [
		3013
	],
	"3897": [
		3897
	],
	"4526": [
		4526
	],
	"4911": [
		4911
	],
	"5135": [
		5135
	],
	"5532": [
		5532
	],
	"5644": [
		5644
	],
	"5682": [
		5682
	],
	"8338": [
		8338
	],
	"8388": [
		8388
	],
	"8491": [
		8491
	],
	"8783": [
		8783
	]
};
var idToExternalAndNameMapping = {
	"1471": [
		"default",
		"./list",
		8
	],
	"2643": [
		"default",
		"./details",
		8
	],
	"3013": [
		"default",
		"./details/nutrition-advisor",
		8
	],
	"3897": [
		"default",
		"./details/edit/frequency",
		8
	],
	"4249": [
		"default",
		"./version",
		8
	],
	"4526": [
		"default",
		"./details/confirm-plan",
		8
	],
	"4832": [
		"default",
		"./version",
		2954
	],
	"4911": [
		"default",
		"./checkoutPage",
		5355
	],
	"5135": [
		"default",
		"./details/nutrition-advisor/appointment",
		8
	],
	"5532": [
		"default",
		"./edit-date",
		8
	],
	"5644": [
		"default",
		"./checkoutConfirmationPage",
		5355
	],
	"5682": [
		"default",
		"./details/edit",
		8
	],
	"8338": [
		"default",
		"./details/services",
		8
	],
	"8388": [
		"default",
		"./cartPanelToggle",
		2954
	],
	"8491": [
		"default",
		"./cartPage",
		2954
	],
	"8783": [
		"default",
		"./details/nutrition-advisor/schedule",
		8
	],
	"9122": [
		"default",
		"./version",
		5355
	]
};
var idToRemoteMap = {
	"1471": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 8
		}
	],
	"2643": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 8
		}
	],
	"3013": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 8
		}
	],
	"3897": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 8
		}
	],
	"4249": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 8
		}
	],
	"4526": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 8
		}
	],
	"4832": [
		{
			"externalType": "script",
			"name": "cartMFE",
			"externalModuleId": 2954
		}
	],
	"4911": [
		{
			"externalType": "script",
			"name": "checkoutMFE",
			"externalModuleId": 5355
		}
	],
	"5135": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 8
		}
	],
	"5532": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 8
		}
	],
	"5644": [
		{
			"externalType": "script",
			"name": "checkoutMFE",
			"externalModuleId": 5355
		}
	],
	"5682": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 8
		}
	],
	"8338": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 8
		}
	],
	"8388": [
		{
			"externalType": "script",
			"name": "cartMFE",
			"externalModuleId": 2954
		}
	],
	"8491": [
		{
			"externalType": "script",
			"name": "cartMFE",
			"externalModuleId": 2954
		}
	],
	"8783": [
		{
			"externalType": "script",
			"name": "subscriptionMFE",
			"externalModuleId": 8
		}
	],
	"9122": [
		{
			"externalType": "script",
			"name": "checkoutMFE",
			"externalModuleId": 5355
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}